import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";

function MomSysMachineStateRecord ( props ) {

    return <BasicCrudScreenType noCreate noEdit noDelete noExcel id="MomSysMachineStateRecord" table="MomSysMachineStateRecord" view="MomSysVwMachineStateRecord" />

}

export default MomSysMachineStateRecord;
